/**
列定义结构体转换工具类
ver 1.0.0
修改记录：
  2018-8-1：
*/
import converterUtil from './converterUtil'
let tableDefinitionConverterUtil = {}

//模糊匹配设置默认宽度
tableDefinitionConverterUtil.columnWidth = {
  90: ['基本单位', '人员'],
  70: ['状态', '单位'],
  120: [
    '日期',
    '计划数量',
    '订购数量',
    '报价',
    '含税单价',
    '无税单价',
    '无税金额',
    '税额',
    '折扣额',
    '含税金额',
    '价税合计',
    '有效期至',
  ],
  170: ['时间'],
  180: ['灭菌批号', '生产批号'], //需求3972
  140: ['数量', '编码', '单据', '金额'],
  320: ['通用名', '生产许可证号', '注册证号/批准文号/备案凭证号', '商品名称'],
  300: ['企业'],
}

//需要精确匹配才能设置默认宽度
tableDefinitionConverterUtil.columnWidthPrecise = [
  '含税单价',
  '含税金额',
  '无税单价',
  '无税金额',
  '税额',
  '折扣额',
  '基本单位数量',
  '需求数量',
  '单位',
  '数量',
  '基本单位',
]

/**
 特殊协议转换适配器，定义类。
 属性名使用 组件类型。
 groupLabel：特殊转换器，1.显示名优先注入到标题。2.支持锚点提取
*/
tableDefinitionConverterUtil.converterAdapter = {
  // //特殊转换器，1.显示名优先注入到标题。2.支持锚点提取
  // "groupLabel": (item, data) => {
  //
  //
  // }
}

/**
 * 将盘谷后台定义动态表单结构体转换成 form-create 要求的结构体
 * @param {object} data scc后台定义结构体
 @param {boolean} disabled 所有组件是否设置为只读模式

 * @return {object} data 转换成form-create 要求的结构体

 */
tableDefinitionConverterUtil.converterByDictFormData = function (
  data,
  disabled,
  strategy,
  defaultSort
) {
  if (!data) return data

  data.items = this.converterItems(data.items, data, disabled, strategy, defaultSort)
  return data
}

/***
 *判断必须全匹配才能设置宽度
 */
tableDefinitionConverterUtil.columnWidthPreciseFn = function (str, label, arr = []) {
  let temp = true
  for (let val of arr) {
    if (val === label) return true
    if (val.indexOf(str) != -1) temp = false
  }
  return temp
}
/**
 * 将每个定义表单输入控件，转换成组件要求的协议。
 * @param {array} items scc后台定义结构体的元素列表
 * @param {object} data scc后台定义结构体
 @param {boolean} disabled 所有组件是否设置为只读模式
 * @return {object} items 转换成form-create 要求的结构体

 */
tableDefinitionConverterUtil.converterItems = function (
  items,
  data,
  disabled,
  strategy,
  defaultSort
) {
  if (!items) return items
  let leftArr = [],
    middleArr = [],
    rightArr = []
  for (var i = 0; i < items.length; i++) {
    var item = items[i]
    // 排序字段如果是false 默认置空
    if (defaultSort?.length > 0) {
      defaultSort.forEach((im) => {
        if (im.id != item.id) item['ascOrder'] = null
      })
    }
    //数据类型
    if (item.type && item.type.code) {
      item.typeCode = item.type.code
    }
    //兼容老数据，直接设置为prop
    if (!item.hasOwnProperty('property')) {
      item.property = item.prop
    }

    this.converterDataTypeDefinition(item, null, null, strategy)
    converterUtil.formatConverterDetal(item, strategy)

    if (
      item.component &&
      (item.component.code == 'panguDatePicker' ||
        item.component.code == 'datePicker' ||
        item.component.code == 'DatePicker')
    ) {
      if (!item.width) item.minWidth = '140'
    } else {
      for (let i in this.columnWidth) {
        for (let j = 0; j < this.columnWidth[i].length; j++) {
          if (
            item.label &&
            item.label.indexOf(this.columnWidth[i][j]) != -1 &&
            tableDefinitionConverterUtil.columnWidthPreciseFn(
              this.columnWidth[i][j],
              item.label,
              tableDefinitionConverterUtil.columnWidthPrecise
            ) &&
            (!item.width || item.width === '')
          ) {
            item.minWidth = i
          }
        }
      }
    }
    //调整配置顺序
    if (item.fixed == 'left') {
      leftArr.push(item)
    } else if (item.fixed == 'right') {
      rightArr.push(item)
    } else {
      middleArr.push(item)
    }
  }
  items = [...leftArr, ...middleArr, ...rightArr]

  return items
}

/**
 * 根据数据类型强制转换输入组件，才能使 验证表达式生效。
 * @param {object} item scc后台定义结构体的元素
 * @param {object} data scc后台定义结构体
 @param {boolean} disabled 所有组件是否设置为只读模式

 */
tableDefinitionConverterUtil.converterDataTypeDefinition = function (
  item,
  data,
  disabled,
  strategy
) {
  var numberTypeArray = ['FLOAT', 'DOUBLE', 'DECIMAL', 'MONEY', 'LONG', 'INTEGER']
  //如果是number类型默认设置表格对齐方式居右
  if (
    item.type &&
    numberTypeArray.indexOf(item.type.code) > -1 &&
    !item.align &&
    item.component &&
    (item.component.code == 'readText' || item.component.code == 'readTextTwo')
  ) {
    item.align = 'right'
  }
  // 如果是名称和描述对齐方式默认居左 默认是居中的
  if (!item.align && item.name && ['名称', '描述'].some((im) => item.name.indexOf(im) > -1))
    item.align = 'left'
  if (!item.type || !item.type.code || !item.component || item.component.code == 'readText') {
    return
  }
  //数字类型强制转换输入组件，才能使 验证表达式生效。
  if (!item.component) item.component = {}
  if (!item.parameter) item.parameter = {}
  if (numberTypeArray.indexOf(item.type.code) > -1 && item.component.code == 'input') {
    item.component.code = 'inputNumber'
  }
  if (item.component.code == 'inputNumber') {
    item.component.code = 'panguInputNumber'
  }

  //设置数字输入框的小数位
  if (
    item.format &&
    (item.component.code == 'panguInputNumber' || item.component.code == 'referencePrice') &&
    !item.parameter.precision
  ) {
    //数字类型
    if (item.format.code == 'NUMBER') {
      item.parameter.precision = strategy.POLICY_NUMBER_PRECISION
        ? parseInt(strategy.POLICY_NUMBER_PRECISION)
        : 6
    }
    //金额类型
    if (item.format.code == 'CURRENCY') {
      item.parameter.precision = 2
    }
    //单据类型
    if (item.format.code == 'PRICE') {
      item.parameter.precision = strategy.POLICY_PRICE_PRECISION
        ? parseInt(strategy.POLICY_PRICE_PRECISION)
        : 6
    }
    //百分比类型
    if (item.format.code == 'PERCENT') {
      item.parameter.precision = 6
    }
    //进度百分比类型
    if (item.format.code == 'PROGRESS') {
      item.parameter.precision = 6
    }
  }
}

//

/**
 * 获取允许显示的组件列表
 * @param {array} items scc后台定义结构体的元素列表
 * @param {object} data scc后台定义结构体
 * @return {object} items 过滤后的组件列表
 */
tableDefinitionConverterUtil.getItemsForFilterVisible = function (items, data, onlyShowFields) {
  var filterItems = []
  if (!items) return filterItems
  for (var i = 0; i < items.length; i++) {
    var item = items[i]
    //存在定义，并且为false，则认为不显示
    if (item.hasOwnProperty('visible') && item.visible === false) {
      continue
    }

    //仅显示指定列，配合分组统计功能。
    if (onlyShowFields && onlyShowFields.length > 0) {
      if (onlyShowFields.indexOf(item.property) == -1) {
        continue
      }
    }

    filterItems.push(item)
  }

  return filterItems
}

export default tableDefinitionConverterUtil
